/**
 * Who may reach the voucher-campaign operator screens.
 *
 * The campaigns are co-branded, and the partner reviews their own registrations
 * in the portal, so these pages are not ryd-internal-only: Stellantis signs in
 * and approves or rejects each address themselves.
 *
 * This list only opens the *route*. Which campaigns a signed-in user actually
 * sees is decided server-side in rp-users (`promoCampaignsVisibleTo`), because a
 * route guard in the browser is not a data boundary.
 */

/** Portal user groups of campaign partners, besides ryd staff. */
export const PROMO_CAMPAIGN_PARTNER_USER_GROUPS = ['stellantis_auto_sas'] as const;

/** Every user group allowed onto the campaign screens. */
export const PROMO_CAMPAIGN_USER_GROUPS: string[] = ['ryd', ...PROMO_CAMPAIGN_PARTNER_USER_GROUPS];
